import apiManager from '../lib/apiManager';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

/**
 * Get browser's unique device ID (user agent fingerprint)
 * @returns {string} Device ID based on user agent
 */
export const getDeviceId = () => {
  // Use navigator.userAgent as a base for device ID
  // In production, you might want to use a more sophisticated fingerprinting library
  const userAgent = navigator.userAgent;
  
  // Create a simple hash from user agent (you can enhance this)
  let hash = 0;
  for (let i = 0; i < userAgent.length; i++) {
    const char = userAgent.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Generate a UUID-like format using the hash and timestamp
  const timestamp = Date.now();
  return `${Math.abs(hash).toString(16)}-${timestamp.toString(16)}-${Math.random().toString(16).substr(2, 8)}`;
};

/**
 * Authenticate mobile device and get patient-specific token
 * @param {Object} params - Parameters
 * @param {number|string} params.PatientId - Patient ID (required)
 * @param {string} params.DeviceId - Device ID (optional, will auto-generate if not provided)
 * @param {string} params.Platform - Platform (default: 'web')
 * @param {string} params.AppVersion - App version (default: '1')
 * @param {string} otpToken - OTP Bearer token (required)
 * @returns {Promise} API response with device authentication data and tokens
 */
export const authenticateDevice = async (params, otpToken) => {
  try {
    const payload = {
      PatientId: params.PatientId,
      DeviceId: params.DeviceId || getDeviceId(),
      Platform: params.Platform || 'web',
      AppVersion: params.AppVersion || '1',
      PreAuth: true
    };

    // Prepare request config with OTP Bearer token
    const config = {
      headers: {
        'Authorization': `Bearer ${otpToken}`
      }
    };

    const response = await apiManager.post(`${API_BASE_URL}/MobileDeviceAuthenticate`, payload, config);
    
    return response.data;
  } catch (error) {
    console.error('Error authenticating device:', error);
    throw error;
  }
};
